import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SelectedSession } from '@app/core/_services'
import { SelectedSessionsListItemComponent } from '../selected-sessions-list-item/selected-sessions-list-item.component'
import { UserService } from '@app/core/_services/user.service'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'fm-selected-sessions-list',
    imports: [CommonModule, SelectedSessionsListItemComponent],
    templateUrl: './selected-sessions-list.component.html',
    styleUrl: './selected-sessions-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedSessionsListComponent {
    @Input() selectedSessions: SelectedSession[] = []

    constructor(public userService: UserService) {}
}
